import React, { useRef, useState } from "react";
import useVendorStore from "../HomePage/useVendorStore";
import { useEffect } from "react";
import { WhiteWrapper } from "../Common/styles.common";
import { GrnCard } from "./GrnCard";
import { Loader } from "../Common/Loader";
import {
  CrossIconWrapper,
  FilterChip,
  FiltersRow,
  GrnPageWrapper,
  SearchBar,
  SearchBarContainer,
  SearchIcon,
  SearchToggleButton,
  SearchToggleIcon,
} from "./styles.grn";
import {
  GRN_STATUS_COMPLETED,
  STATUS_BEGIN,
  STATUS_DONE,
  STATUS_FAIL,
  PO_ORDER_TAG_MANDI_DD, PO_ORDER_TAG_DIRECT_DELIVERY,
  PAYMENT_STATUS_NOT_PAID,
  GRN_OR_FILTER_VALUES,
} from "utils/constants/others";
import { strings } from "utils/constants/strings";
import InfiniteScroll from "react-infinite-scroll-component";
import BackButton from "../Button/BackButton";
import ShowToast from "../Common/Toast";
import Cross from "sushiweb/Icons/all/Cross";
import { GRN_OR_FILTERS } from "./utils";

const GrnList = () => {
  const poGrnMappings = useVendorStore((state) => state.poGrnList);
  const getPoGrnMappings = useVendorStore((state) => state.getPoGrnMappings);
  const getPoGrnMappingStatus = useVendorStore(
    (state) => state.getPoGrnMappingStatus
  );
  const poGrnHasNextPage = useVendorStore((state) => state.poGrnHasNextPage);
  const outletId = window.localStorage.getItem("outlet_id");
  const storedGrnListSearchFilters = useVendorStore((state) => state.grnListSearchFilters);
  const setGrnListSearchFilters = useVendorStore((state) => state.setGrnListSearchFilters);

  const [showLoader, setShowLoader] = useState(false);
  const [pageNumber,setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const abortControllerRef = useRef(null);
  const [showToast,setShowToast] = useState(false)
  const [grnListSearchFilters, setGrnListSearchFiltersLocal] = useState(() => storedGrnListSearchFilters);
  const [debouncedSearchString, setDebouncedSearchString] = useState(() => storedGrnListSearchFilters.searchString.trim());
  const hasMountedSearchEffect = useRef(false);

  const { orFilters, isSearchOpen, searchString } = grnListSearchFilters;
  const effectiveOrFilters = isSearchOpen && debouncedSearchString.length > 0 ? [] : orFilters;

  useEffect(() => { setGrnListSearchFilters(grnListSearchFilters); }, [grnListSearchFilters]);

  const fetchPoGrnMappings = (page, isFirstPage) => {
    const confirmedSelected = effectiveOrFilters.includes(GRN_OR_FILTER_VALUES.SELLER_STATUS_APPROVED);
    const paidSelected = effectiveOrFilters.includes(GRN_OR_FILTER_VALUES.PAYMENT_STATUS_PAID);
    // To not show paid grn in approved
    const paymentStatus = confirmedSelected && !paidSelected ? PAYMENT_STATUS_NOT_PAID : "";

    let signal;
    if (isFirstPage) {
      // Cancel any in-flight first-page request before firing a new one
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();
      signal = abortControllerRef.current.signal;
    }

    getPoGrnMappings({
      page_number: page,
      grn_status: GRN_STATUS_COMPLETED,
      page_size: 20,
      outlet_id: outletId,
      fetch_ledger_data: true,
      is_payment_details_required: true,
      or_filters: effectiveOrFilters,
      exclude_purchase_order_tags: `${PO_ORDER_TAG_MANDI_DD},${PO_ORDER_TAG_DIRECT_DELIVERY}`,
      search_string: debouncedSearchString,
      skip_total_page_count: true,
      payment_status: paymentStatus,
    }, isFirstPage, signal);
  };

  useEffect(() => {
    setPageNumber(1);
    setHasMore(true);
    fetchPoGrnMappings(1, true);
  }, [orFilters]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setDebouncedSearchString(searchString.trim());
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [searchString]);

  useEffect(() => {
    if (!hasMountedSearchEffect.current) {
      hasMountedSearchEffect.current = true;
      return;
    }

    setPageNumber(1);
    setHasMore(true);
    fetchPoGrnMappings(1, true);
  }, [debouncedSearchString]);

  useEffect(() => {
    switch (getPoGrnMappingStatus) {
      case STATUS_BEGIN:
        setShowLoader(true);
        break;
      case STATUS_DONE: {
        setHasMore(!!poGrnHasNextPage);
        setShowLoader(false);
        break;
      }
      case STATUS_FAIL:
        setShowLoader(false);
        setShowToast(true);
        break;
    }
  }, [getPoGrnMappingStatus]);

  const toggleFilter = (filterValue) => {
    setGrnListSearchFiltersLocal((prev) => {
      const currentFilters = prev.orFilters;
      const updatedFilters = currentFilters.includes(filterValue)
        ? currentFilters.filter((value) => value !== filterValue)
        : [...currentFilters, filterValue];
      return { ...prev, orFilters: updatedFilters };
    });
  };

  let cards = [];

  if (poGrnMappings && poGrnMappings.length) {
    for (let index = 0; index < poGrnMappings.length; index++) {
      cards.push(<GrnCard key={index} grn={poGrnMappings[index]} source={"list"}/>);
    }
  }

  const loadNextPage = () => {
    const nextPage = pageNumber + 1;

    fetchPoGrnMappings(nextPage, false);
    setPageNumber(nextPage)
  };

  const handleSearchToggle = () => {
    if (isSearchOpen) {
      setGrnListSearchFiltersLocal((prev) => ({ ...prev, searchString: "", isSearchOpen: false }));
    } else {
      setGrnListSearchFiltersLocal((prev) => ({ ...prev, isSearchOpen: true }));
    }
  };

  const shouldShowListLoader = showLoader && pageNumber === 1;
  const shouldShowEmptyState =
    !shouldShowListLoader &&
    getPoGrnMappingStatus === STATUS_DONE &&
    cards.length === 0;

  return (
    <React.Fragment>
      <GrnPageWrapper className="d-flex flex-column">
        <WhiteWrapper>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <BackButton pathName={"/"}/>
              <span className="fs-16 fw-600">GRNs</span>
            </div>
            <SearchToggleButton onClick={handleSearchToggle} aria-label="Toggle search">
              <SearchToggleIcon src="/logos/search-basic.svg" alt="search" />
            </SearchToggleButton>
          </div>
          {isSearchOpen ? (
            <div className="mt-4">
              <SearchBarContainer>
                <SearchIcon src="/logos/search-basic.svg" alt="search" />
                <SearchBar
                  type="text"
                  placeholder={strings.searchGRNList}
                  value={searchString}
                  onChange={(event) => setGrnListSearchFiltersLocal((prev) => ({ ...prev, searchString: event.target.value }))}
                />
              </SearchBarContainer>
            </div>
          ) : null}
        </WhiteWrapper>
        <FiltersRow>
          {GRN_OR_FILTERS.map((filter) => {
            const isSelected = orFilters.includes(filter.value);

            return (
              <FilterChip
                key={filter.value}
                $selected={isSelected}
                onClick={() => toggleFilter(filter.value)}
                type="button"
              >
                <span className="fs-13">{filter.label}</span>
                {isSelected ? (
                  <CrossIconWrapper
                    onClick={(event) => {
                      event.stopPropagation();
                      toggleFilter(filter.value);
                    }}
                  >
                    <Cross color="#293142" height={16} width={16} />
                  </CrossIconWrapper>
                ) : null}
              </FilterChip>
            );
          })}
        </FiltersRow>
        {shouldShowListLoader ? (
          <div className="mt-4">
            <Loader isScrollLoader={true} />
          </div>
        ) : shouldShowEmptyState ? (
          <div className="d-flex justify-content-center mt-6">
            <span className="fs-14 fw-400 text-gray-cool">
              {strings.noGrnsFound}
            </span>
          </div>
        ) : (
 <InfiniteScroll
            className="infinite-scroll"
            height={"87%"}
            dataLength={cards.length}
            hasMore={hasMore}
            next={loadNextPage}
            loader={<Loader isScrollLoader={true}/>}
          >
            {cards}
          </InfiniteScroll>
        )}
      </GrnPageWrapper>
      {showToast?
        <ShowToast/>
        :
        <></>
      }
    </React.Fragment>
  );
};

export default GrnList;
